import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";

export class AppCitationPart {
    public Text: string = "";
    public ChatId: string = "";
    public MessageId: string = "";
}

/** Server-verified final evidence tokens only. Streamed raw source tokens remain inert text. */
export class AppAssistCitations {
    public static readonly Trust: string = "serverallowlist";
    /** ERROR-SUPPRESSED-JUSTIFIED: malformed optional metadata is expected outside input. */
    public static KeysIn = (Raw: unknown): string[] | null => {
        if (Raw === undefined) { return []; }
        if (Array.isArray(Raw) === false || (Raw as unknown[]).length > 512) { return null; }
        const Out: string[] = [];
        for (const Key of Raw as unknown[]) {
            if (typeof Key !== "string" || /^[0-9]+@(s\.whatsapp\.net|lid)\/[A-Za-z0-9_-]{1,128}$/.test(Key) === false || Key.length > 256) { return null; }
            if (Out.indexOf(Key) < 0) { Out.push(Key); }
        }
        return Out;
    };

    public static Keys = (Text: string, Allowed: string[]): string[] => {
        if (getCoreUtils().KErrorMode === true) { return []; }
        try {
            const Out: string[] = [];
            for (const Part of AppAssistCitations.Parts(Text, Allowed)) {
                if (Part.ChatId.length === 0) { continue; }
                const Key: string = Part.ChatId + "/" + Part.MessageId;
                if (Out.indexOf(Key) < 0 && Out.length < 512) { Out.push(Key); }
            }
            return Out;
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppAssistCitations.Keys"); return []; }
    };

    public static Parts = (Text: string, Sources: string[] = []): AppCitationPart[] => {
        if (getCoreUtils().KErrorMode === true) { return []; }
        try {
            const Out: AppCitationPart[] = [];
            const Allowed: Set<string> = new Set<string>(Sources);
            const Pattern: RegExp = /\[evidence: ([0-9]+@(s\.whatsapp\.net|lid))\/([A-Za-z0-9_-]{1,128})\]/g;
            let At: number = 0;
            let Match: RegExpExecArray | null = Pattern.exec(Text);
            while (Match !== null) {
                if (Allowed.has(Match[1] + "/" + Match[3]) === false) { Match = Pattern.exec(Text); continue; }
                const Before: AppCitationPart = new AppCitationPart();
                Before.Text = Text.substring(At, Match.index); Out.push(Before);
                const Source: AppCitationPart = new AppCitationPart();
                Source.ChatId = Match[1]; Source.MessageId = Match[3]; Out.push(Source);
                At = Match.index + Match[0].length; Match = Pattern.exec(Text);
            }
            const Last: AppCitationPart = new AppCitationPart(); Last.Text = Text.substring(At); Out.push(Last);
            return Out;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistCitations.Parts");
            return [];
        }
    };
}
